module.exports = __webpack_public_path__ + "img/avatarImg.cdce3041.png";